var map = {
	"./assets/Whitespace_Logo_Colour.svg": [
		415,
		3
	],
	"./assets/collectorIcons/binTruckIcon.svg": [
		416,
		4
	],
	"./assets/itemorderIcons/Clothing.svg": [
		417,
		5
	],
	"./assets/itemorderIcons/Equipment.svg": [
		418,
		6
	],
	"./assets/itemorderIcons/Other.svg": [
		419,
		7
	],
	"./assets/wasteTypeIcons/Battery Icon.svg": [
		420,
		8
	],
	"./assets/wasteTypeIcons/Books Icon.svg": [
		421,
		9
	],
	"./assets/wasteTypeIcons/Brown Glass Icon.svg": [
		422,
		10
	],
	"./assets/wasteTypeIcons/Car Battery Icon.svg": [
		423,
		11
	],
	"./assets/wasteTypeIcons/Cardboard Icon.svg": [
		424,
		12
	],
	"./assets/wasteTypeIcons/Carpet Icon.svg": [
		425,
		13
	],
	"./assets/wasteTypeIcons/Chemicals Icon.svg": [
		426,
		14
	],
	"./assets/wasteTypeIcons/Clear Glass Icon.svg": [
		427,
		15
	],
	"./assets/wasteTypeIcons/Cooking Oil Icon.svg": [
		428,
		16
	],
	"./assets/wasteTypeIcons/Discs Icon.svg": [
		429,
		17
	],
	"./assets/wasteTypeIcons/ERF Icon.svg": [
		430,
		18
	],
	"./assets/wasteTypeIcons/Electrical Icon.svg": [
		431,
		19
	],
	"./assets/wasteTypeIcons/Engine Oil Icon.svg": [
		432,
		20
	],
	"./assets/wasteTypeIcons/F Tube Icon.svg": [
		433,
		21
	],
	"./assets/wasteTypeIcons/Fridge Freezer Icon.svg": [
		434,
		22
	],
	"./assets/wasteTypeIcons/Garden Icon.svg": [
		435,
		23
	],
	"./assets/wasteTypeIcons/Gas Bottles Icon.svg": [
		436,
		24
	],
	"./assets/wasteTypeIcons/Green Glass Icon.svg": [
		437,
		25
	],
	"./assets/wasteTypeIcons/Hard Plastic Icon.svg": [
		438,
		26
	],
	"./assets/wasteTypeIcons/Household Icon.svg": [
		439,
		27
	],
	"./assets/wasteTypeIcons/Light Bulb Icon.svg": [
		440,
		28
	],
	"./assets/wasteTypeIcons/Mattress Icon.svg": [
		441,
		29
	],
	"./assets/wasteTypeIcons/Metal Icon.svg": [
		442,
		30
	],
	"./assets/wasteTypeIcons/Mix Glass Icon.svg": [
		443,
		31
	],
	"./assets/wasteTypeIcons/Newspapers Icon.svg": [
		444,
		32
	],
	"./assets/wasteTypeIcons/Paint Icon.svg": [
		445,
		33
	],
	"./assets/wasteTypeIcons/Paper Icon.svg": [
		446,
		34
	],
	"./assets/wasteTypeIcons/Plasterboard Icon.svg": [
		447,
		35
	],
	"./assets/wasteTypeIcons/Plastic Icon.svg": [
		448,
		36
	],
	"./assets/wasteTypeIcons/Rubble Soil Icon.svg": [
		449,
		37
	],
	"./assets/wasteTypeIcons/Small Appliances Icon.svg": [
		450,
		38
	],
	"./assets/wasteTypeIcons/Spare Icon.svg": [
		451,
		39
	],
	"./assets/wasteTypeIcons/TV Monitor Icon.svg": [
		452,
		40
	],
	"./assets/wasteTypeIcons/Textiles Icon.svg": [
		453,
		41
	],
	"./assets/wasteTypeIcons/Tin Icon.svg": [
		454,
		42
	],
	"./assets/wasteTypeIcons/Tyre Icon.svg": [
		455,
		43
	],
	"./assets/wasteTypeIcons/UPVC Frame Icon.svg": [
		456,
		44
	],
	"./assets/wasteTypeIcons/Wood Clean Icon.svg": [
		457,
		45
	],
	"./assets/wasteTypeIcons/Wood Icon.svg": [
		458,
		46
	],
	"./assets/wasteTypeIcons/Wood LGT Icon.svg": [
		459,
		47
	],
	"./assets/wasteTypeIcons/unknown.svg": [
		460,
		48
	],
	"./assets/weatherIcons/Cloudy Weather Icon.svg": [
		461,
		49
	],
	"./assets/weatherIcons/Heavy Rain Icon.svg": [
		462,
		50
	],
	"./assets/weatherIcons/Heavy Snow Icon.svg": [
		463,
		51
	],
	"./assets/weatherIcons/Light Rain Icon.svg": [
		464,
		52
	],
	"./assets/weatherIcons/Light Snow Icon.svg": [
		465,
		53
	],
	"./assets/weatherIcons/Part Cloud Weather Icon.svg": [
		466,
		54
	],
	"./assets/weatherIcons/Select Weather Icon.svg": [
		467,
		55
	],
	"./assets/weatherIcons/Sleet Icon.svg": [
		468,
		56
	],
	"./assets/weatherIcons/Stormy Icon.svg": [
		469,
		57
	],
	"./assets/weatherIcons/Sunny Weather Icon.svg": [
		470,
		58
	],
	"./assets/weatherIcons/V Cold Icon.svg": [
		471,
		59
	],
	"./assets/weatherIcons/V Hot Icon.svg": [
		472,
		60
	],
	"./assets/weatherIcons/Windy Icon.svg": [
		473,
		61
	],
	"./logo.svg": [
		474,
		62
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 391;
module.exports = webpackAsyncContext;